// Approximate, illustrative historical extents for education — not surveyed legal boundaries.
export const TERRITORIES = [
  {
    id: "territories", name: "Cherokee Homeland (pre-removal)", tribe: "Cherokee",
    color: "#59288E", untilYear: 1838,
    coords: [[35.9, -84.6], [35.6, -82.9], [34.6, -83.4], [34.2, -84.6], [34.7, -85.6], [35.4, -85.4], [35.9, -84.6]],
  },
  {
    id: "territories", name: "Choctaw Homeland (pre-removal)", tribe: "Choctaw",
    color: "#3F1E68", untilYear: 1831,
    coords: [[33.6, -90.3], [33.0, -88.2], [31.7, -88.4], [31.3, -89.9], [32.1, -90.6], [33.6, -90.3]],
  },
  {
    id: "territories", name: "Muscogee (Creek) Homeland", tribe: "Creek",
    color: "#6D28D9", untilYear: 1836,
    coords: [[33.8, -86.2], [33.4, -84.0], [31.9, -83.6], [31.3, -85.4], [32.4, -86.6], [33.8, -86.2]],
  },
  {
    id: "territories", name: "Seminole Homeland", tribe: "Seminole",
    color: "#7C3AED", untilYear: 1842,
    coords: [[29.9, -82.6], [29.7, -81.2], [27.5, -80.6], [26.4, -81.4], [27.6, -82.4], [29.0, -82.9], [29.9, -82.6]],
  },
  {
    id: "reservations", name: "Indian Territory (relocation lands)", tribe: "Five Tribes",
    color: "#10B981", fromYear: 1838,
    coords: [[37.0, -100.0], [37.0, -94.6], [33.6, -94.4], [33.9, -100.0], [37.0, -100.0]],
  },
];

// Trail of Tears — approximate northern & water routes (Choctaw / Cherokee removal corridor).
export const TRAIL_OF_TEARS = {
  id: "migration", name: "Trail of Tears (approx. removal route)", color: "#EF4444",
  path: [
    [34.0, -84.4],  // Georgia (Cherokee)
    [35.0, -85.3],  // Chattanooga TN
    [35.9, -86.9],  // Nashville TN
    [37.0, -89.2],  // Cape Girardeau MO
    [36.6, -91.5],  // southern MO
    [36.1, -94.2],  // NW Arkansas
    [35.6, -95.9],  // Indian Territory (Tahlequah area)
  ],
};

// Pin coordinates for the researcher's own ancestors.
export const ANCESTOR_PINS = [
  { name: "Sarah Johnson household", note: "Kemper County, Mississippi — 1880 census.", year: 1880, lat: 32.75, lng: -88.65, layer: "ancestors" },
  { name: "Mary Johnson household", note: "Tishomingo, Chickasaw Nation, I.T. — 1900 census.", year: 1900, lat: 34.24, lng: -96.68, layer: "ancestors" },
  { name: "Blue River community church", note: "Referenced in 1907 newspaper.", year: 1907, lat: 34.15, lng: -96.4, layer: "churches" },
  { name: "Ella Johnson allotment", note: "40-acre Choctaw allotment, 1904.", year: 1904, lat: 34.3, lng: -96.5, layer: "ancestors" },
];
